module.exports = __webpack_public_path__ + "img/logement-soho.8484b010.png";